<template>
  <div class="fixed-wrapper" @click.self="$emit('close')">
    <div class="k-modal-window">
      <div class="loading-indication" v-if="busyState">
        <k-spinner />
      </div>

      <go-back class="k-modal-go-back mb-2" @click="$emit('close')" />
      <div class="k-modal-window__wrapper">
        <div v-if="getPriceWithDiscount && !locked" class="text-center mb-3">
          <div class="k-modal-title">Сумма к оплате:</div>
          <div class="k-modal-sticker subscribe-pormocode">
            <input type="text" :value="`${getPriceWithDiscount}р`" readonly/>
          </div>
        </div>
        <div>
          <div v-if="!apliedPromo && checkCurrentPormoInputExist">
            <div class="k-modal-title mb-2" v-if="!locked">Укажите промокод:</div>
            <div class="k-modal-title mb-2" v-else>Чтобы получить доступ к меню, введите промокод</div>
            <div class="k-modal-sticker subscribe-pormocode">
              <input type="text" v-model="promo" />
            </div>
            <p v-if="promoError" class="text-center">Указан неверный промокод</p>
            <div class="k-modal-button mt-3 mb-5" @click="setPromocode" :disabled="!promo">{{ !locked ? 'Применить' : 'Разблокировать' }}</div>
          </div>
          <div v-else-if="checkCurrentPormoInputExist" class="text-center">
            Промокод успешно применен
          </div>
          <div class="k-modal-button k-modal-button--orange mt-2" v-if="!locked" @click="pay">Оплатить</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoBack from "../../components/TheGoBack";
import { buySpecialMenu, addUserToSet } from "../../api/SubscribeApi";
import { mapActions, mapGetters } from 'vuex';
import KSpinner from '../../components/TheSpinner';

export default {
  props: {
    setId: String,
    locked: Boolean,
  },
  components: {
    GoBack,
    KSpinner
  },
  data: () => ({
    promo: "",
    promoError: false,
    promo_discount: null,
    apliedPromo: false,
    busyState: false,
  }),
  mounted() {
    console.log('here')
    this.promoError = false;
    this.promo_discount = null;
    this.apliedPromo = false;
    this.promo = '';
  },
  computed: {
    ...mapGetters([
      'getUserFamily',
      'getAvaiableUserSets',
      'getUserSets',
    ]),
    getMainProfile() {
      return this.getUserFamily.find(el => el.is_main === "t");
    },
    subscribeExist() {
      return this.getUserSets.find(el => el.recipe_set_id === this.setId)
    },
    subscribeData() {
      return this.getAvaiableUserSets.find(el => el.id === this.setId)
    },
    notExistPromoOn() {
      return [
        /*
        '997b2e8f-13ba-4622-8f4f-b6f3e060083b',
        '1f9e97c4-5d42-4307-ac1c-daa360a047f0',
        */
      ]
    },
    checkCurrentPormoInputExist() {
      return !this.notExistPromoOn.includes(this.setId)
    },
    getValidPromocode() {
      switch (this.setId) {
        case '0d95ba19-64c2-4210-93c6-fa6c19e73ac1': return 'INTEGRA10'
        default: return null;
      }
    },
    getPriceWithDiscount() {
      if (this.promo_discount) return this.promo_discount;
      if (!this.subscribeData.price) return 0;
      return this.subscribeData.price
    }
  },
  methods: {
    ...mapActions([
      'loadUser',
    ]),
    async setPromocode() {
      if (this.busyState) return;

      this.promoError = false;
      this.promo_discount = null;

      this.busyState = true;

      if (!this.subscribeExist) {
        const { data } = await buySpecialMenu({
          recipe_set_id: this.setId,
          promocode: this.promo ? this.promo.toUpperCase() : undefined,
        });

        if (!data.success) {
          this.apliedPromo = false;
          this.promoError = true;
          this.busyState = false;
          return;
        }

        await addUserToSet({
          profile_id: this.getMainProfile.id,
          recipe_set_id: this.setId,
        });

        if (this.promo) {
          this.promo_discount = data.data.user_recipe_set.total_cost
        }
      } else {
        const { data } = await buySpecialMenu({
          recipe_set_id: this.setId,
          promocode: this.promo ? this.promo.toUpperCase() : undefined,
        }, true, this.subscribeExist.id);

        if (!data.success) {
          this.apliedPromo = false;
          this.promoError = true;
          this.busyState = false;
          return;
        }

        if (this.promo) {
          this.promo_discount = data.data.user_recipe_set.total_cost
        }
      }

      if (this.locked) {
        await this.loadUser();
        this.$emit('close');
      }

      this.apliedPromo = true;
      this.busyState = false;
    },
    async pay() {
      if (this.busyState) return;

      this.busyState = true;

      if (!this.subscribeExist) {
        const { data } = await buySpecialMenu({
          recipe_set_id: this.setId,
          promocode: this.promo && this.apliedPromo ? this.promo.toUpperCase() : undefined,
        });

        await addUserToSet({
          profile_id: this.getMainProfile.id,
          recipe_set_id: this.setId,
        });

        if (data.data.user_recipe_set.confirmation_url) {
          location.href = data.data.user_recipe_set.confirmation_url;
        } else {
          await this.loadUser();
          this.busyState = false;
        }
      } else {
        const { data } = await buySpecialMenu({
          recipe_set_id: this.setId,
          promocode: this.promo ? this.promo.toUpperCase() : undefined,
        }, true, this.subscribeExist.id);

        if (data.data.user_recipe_set.confirmation_url) {
          location.href = data.data.user_recipe_set.confirmation_url;
        } else {
          await this.loadUser();
          this.busyState = false;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.fixed-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.15);
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 60px;
}

.k-modal-window {
  width: 100%;
  height: 100%;
  max-width: 820px;
  max-height: 596px;

  background: #ffffff;
  border: 1px solid #ebebeb;
  box-sizing: border-box;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.05);
  border-radius: 2px;
  padding: 40px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  position: relative;
}

.k-modal-window__arrow {
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  background: #f7981e;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  &.disabled {
    background: #cfd2d3;
    pointer-events: none;
  }
}

.k-modal-go-back {
  display: none;
}

.k-modal-window__wrapper {
  width: 260px;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.k-modal-steps {
  width: 100%;
  display: flex;
}
.k-modal-steps__step {
  min-width: 26px;
  min-height: 26px;
  border-radius: 50%;
  background: #e4e4e4;
  position: relative;
  transition: all 0.25s linear;

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 65%;
    height: 65%;
    background: #fff;
    border-radius: 50%;
  }

  &.active {
    background: #fff;

    &::after {
      background: #f7981e;
      width: 45%;
      height: 45%;
    }
  }

  &.skip {
    background: #f7981e;

    &::after {
      content: unset;
    }
  }
}
.k-modal-steps__linker {
  height: 2px;
  background: #e4e4e4;
  width: 100%;
}

@media (max-width: 767.98px) {
  .k-modal-window {
    padding: 10px !important;
    justify-content: center;
    max-height: 100%;
  }
  .k-modal-window__arrow {
    display: none;
  }
  .k-modal-go-back {
    display: block;
    height: 50px;
    padding-top: 10px;
  }
}
</style>

<style lang="scss">
.k-modal-button,
.k-modal-sticker {
  width: 260px;
  height: 60px;
  background: #ffffff;
  border: 1px solid #cfd2d3;
  box-sizing: border-box;
  border-radius: 8px;
  color: #808080;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.25s linear;
  cursor: pointer;

  &.selected {
    background: #f68c1e;
    color: #fff !important;
    border: unset;
  }
}

.k-modal-button {
  background: #ffcc1b;
  color: #fff;
  border: unset;

  &.disabled {
    background: #c4c4c4;
    opacity: 0.4;
  }

  &--orange {
    background: #f68c1e;
  }
}
.k-modal-title {
  font-size: 20px;
  text-align: center;
  color: #000000;
}

.k-modal-sticker__title {
  font-weight: 600;
  font-size: 16px;
  text-align: center;
}
.k-modal-sticker__subtitle {
  font-weight: 600;
  font-size: 12px;
  text-align: center;
  opacity: 0.6;
}
.k-modal-popper {
  background: #ffffff;
  box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  padding: 10px 20px;
  text-align: center;
}
.subscribe-sticker {
  position: relative;
  overflow: hidden;
}
.subscribe-sticker__sale {
  height: 25px;
  width: 125px;
  background: #9dc43b;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 14px;
  position: absolute;
  top: 0;
  right: 0;
  transform: rotate(30deg) translate(37px, -20px);
}

.subscribe-pormocode {
  border: 1px solid #f68c1e;
  box-sizing: border-box;
  border-radius: 8px;

  input {
    width: 100%;
    border: unset;
    outline: none;
    padding: 0 20%;
    text-align: center;
    font-size: 20px;
    color: #616161;
  }
}
.k-modal-price {
  font-weight: 600;
  font-size: 19px;
}
</style>
